import React from 'react';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import { getCategoriaStatusDisplay } from '../utils/categoriaStatusDisplay';

export interface CategoriaStatusChipProps {
  status?: string | null;
  temPartidas?: boolean | null;
}

const CategoriaStatusChip: React.FC<CategoriaStatusChipProps> = ({ status, temPartidas }) => {
  const cfg = getCategoriaStatusDisplay({ status, temPartidas });
  return (
    <Chip
      // Âncora estável para o e2e. As specs ancoravam em `span.badge` + texto "Encerrada";
      // o A-38 trocou o badge do react-bootstrap por este Chip do MUI E renomeou o rótulo
      // para "Concluída", quebrando 5 specs de uma vez sem que nada de negócio mudasse.
      data-testid="categoria-status-chip"
      label={cfg.label}
      sx={{
        backgroundColor: cfg.bg,
        color: cfg.color,
        fontWeight: 500,
        '& .MuiChip-icon': { marginLeft: 1, marginRight: 0.5 },
      }}
      icon={
        <Box
          aria-hidden="true"
          sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: cfg.color }}
        />
      }
      size="small"
    />
  );
};

export default CategoriaStatusChip;
